import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Item,
  Stack,
  Typography,
  Button,
  Skeleton,
} from "@mui/material";
import axios from "axios";
import { useStateValue } from "../../../StateProvider";

const PressReleasesContainer = () => {
  const [{ token }] = useStateValue();
  const [news, setNews] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    try {
      axios
        .get(
          `https://cloud.iexapis.com/stable/stock/msft/news/last/2?token=${token}`
        )
        .then((res) => {
          // console.log("news", res?.data);
          // setNews([...news, res?.data]);
          axios
            .get(
              `https://cloud.iexapis.com/stable/stock/amzn/news/last/2?token=${token}`
            )
            .then((res2) => {
              // console.log("news", res?.data);
              // setNews([...news, res?.data]);
              axios
                .get(
                  `https://cloud.iexapis.com/stable/stock/aapl/news/last/2?token=${token}`
                )
                .then((res3) => {
                  let arr = [];
                  res?.data.map((r) => arr.push(r));
                  res2?.data.map((r) => arr.push(r));
                  res3?.data.map((r) => arr.push(r));
                  // console.log("news", arr);
                  setNews(arr);
                  setIsLoading(false);
                });
            });
        });
    } catch (err) {
      console.log(err);
    }
  }, []);
  return (
    <Box className="press__releases__container" sx={{ padding: "10px 0" }}>
      <Typography
        variant="h5"
        component="div"
        sx={{
          fontWeight: 600,
          fontSize: "0.8rem",
          fontFamily: "Public Sans,sans-serif",
          marginBottom: "20px",
        }}
      >
        LATEST PRESS RELEASES
      </Typography>
      <Box
        sx={{
          width: "100%",
          padding: "20px 5px",
          //   border: "1px solid #000",
          display: "flex",
          flexWrap: "wrap",
          gap: "20px",
        }}
      >
        {isLoading ? (
          <>
            {new Array(4).fill("x", 0, 3).map((a, i) => (
              <Box
                key={i}
                sx={{
                  width: "250px",
                  background: "white",
                  borderRadius: "8px",
                  overflow: "hidden",
                  border: "1px solid rgb(230, 235, 241)",
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  backgroundColor: "bgPrimary.main",
                }}
              >
                <Skeleton variant="rounded" width={"100%"} height={80} />
                <Skeleton
                  variant="text"
                  width={"50%"}
                  height={20}
                  sx={{ margin: "0 10px 0px 10px" }}
                />
                <Skeleton
                  variant="rounded"
                  width={"80%"}
                  height={30}
                  sx={{ margin: "0 10px 10px 10px" }}
                />
              </Box>
            ))}
          </>
        ) : (
          <>
            {news?.map(
              (n) =>
                n?.image && (
                  <Box
                    sx={{
                      width: "100%",
                      maxWidth: "240px",
                      minWidth: "180px",
                      background: "white",
                      borderRadius: "8px",
                      overflow: "hidden",
                      border: "1px solid rgb(230, 235, 241)",
                      backgroundColor: "bgPrimary.main",
                    }}
                  >
                    {n?.image && (
                      <img
                        className="thumbnail"
                        src={n?.image}
                        style={{ width: "100%", height: "120px" }}
                      />
                    )}

                    <Typography
                      sx={{
                        fontFamily: "Public Sans",
                        fontSize: "0.7rem",
                        fontWeight: "300",
                        padding: "8px",
                      }}
                    >
                      {new Date(n?.datetime).toDateString()} . {n?.source}
                    </Typography>
                    <a
                      href={n?.url}
                      target="_blank"
                      style={{
                        textDecoration: "none",
                        color: "#262626",
                      }}
                    >
                      <Typography
                        sx={{
                          fontFamily: "Public Sans",
                          fontSize: "0.875rem",
                          padding: "8px",
                          fontWeight: "600",
                          color: "fontPrimaryColor.main",
                        }}
                      >
                        {n?.headline}
                      </Typography>
                    </a>
                  </Box>
                )
            )}
          </>
        )}
      </Box>
      {!isLoading && (
        <button
          style={{
            marginLeft: "5px",
            padding: "6px 15px",
            cursor: "pointer",
            backgroundColor: "#052728",
            color: "white",
            border: "1px solid #f6f6f6",
            borderRadius: "15px",
            fontFamily: "public sans",
            fontSize: "0.75rem",
            display: "flex",
            alignItems: "center",
          }}
        >
          {" "}
          CHECKOUT
        </button>
      )}
    </Box>
  );
};

export default PressReleasesContainer;
